import es_ES from './es_ES';
import en_US from './en_US';

export default { es_ES, en_US };


// WEBPACK FOOTER //
// ./websources/languages/index.js